import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { markNotificationAsRead } from '@/services/notification.service';
import { decrementBadge } from '@/store/updates-hub/updatesHubSlice';
import { Notification } from '@/types/notification';

/**
 * Єдина точка "коли користувач взаємодіє з notification — позначити прочитаною".
 *
 * Викликати з будь-якого UI що "відкриває" notification (клік у dropdown,
 * перехід з detail-modal, натиснення "Перейти"). Логіка:
 * 1. Якщо `notification.isRead` — нічого не робимо.
 * 2. Інакше: PUT `/notifications/:id/read` + optimistic decrement бейджа
 *    `state.updatesHub.badges.notifications`. WS-апдейт від беку прийде слідом
 *    і верифікує число — але UI не чекає на нього.
 * 3. Помилки не блокують навігацію (fire-and-forget). Логуються у console.
 *
 * Не маркує локальний state самої notification — за це відповідає компонент-власник
 * (наприклад, refetch списку після переходу). Тут лише глобальний бейдж.
 */
export function useMarkNotificationRead() {
  const dispatch = useDispatch();

  return useCallback((notification: Pick<Notification, 'id' | 'isRead'>) => {
    if (notification.isRead) return;

    dispatch(decrementBadge('notifications'));
    markNotificationAsRead(notification.id).catch(err => {
      console.error('markNotificationAsRead failed', err);
    });
  }, [dispatch]);
}
